import Step from '@/pcp/components/components/Step';

export default function NurseConsult() {
  return <Step divider />;
}
